<template>
  <div>
    <v-card-title primary-title class="headline mast-header" :style="bg">Licence Fees - New</v-card-title>
    <v-card-text>
      <div>
        <v-form ref="form" @submit.prevent="submit" autocomplete="off">
          <div>
            <slot name="form">
              <h4>Select your licence type(s)</h4>
              <br>
              <v-checkbox v-model="includeLicence" label="Recreational boating Licence"></v-checkbox>
              <v-checkbox v-model="includePwc" label="Personal Water Craft (PWC) Endorsement"></v-checkbox>
              <date-field label="Date of Birth*" v-model="dob" :today="false"/>
              <date-field label="Date of Issue*" v-model="startDate" :today="true"/>
            </slot>
          </div>
          <div class="captcha-container">
            <div>
              <h4 v-if="badRequest" class="red--text">
                Could not locate Fee Table. Please contact MAST Online
              </h4>
              <div v-else-if="answer">
                <h4>Cost: ${{answer.toFixed(2)}}</h4>
                <small>{{answerSubtitle}}</small>
              </div>
              <h4 v-else-if="isNaN(answer)" class="red--text">
                {{answerSubtitle}}
              </h4>
            </div>
            <v-btn type="submit" :disabled="!canSubmit">Calculate</v-btn>
          </div>
        </v-form>
      </div>
    </v-card-text>
  </div>
</template>

<script>
import EditField from '@/components/edit-field'
import DateField from '@/components/date-field'
import API from '@/api'
import bg from '@/assets/mast.png'

import moment from 'moment'

export default {
  name: 'checker-view',
  inject: ['$validator'],
  components: { EditField, DateField },
  computed: {
    mobile () {
      return this.$vuetify.breakpoint.name === 'xs'
    },
    canSubmit () {
      return this.feeValues && !this.errors.any()
    },
    bg () {
      return `background-image:url(${bg})`
    }
  },
  data () {
    return {
      length: '',
      dob: '',
      startDate: '',
      badRequest: false,
      feeValues: {},
      answer: null,
      answerSubtitle: '',
      includeLicence: false,
      includePwc: false
    }
  },
  async mounted () {
    this.$validator.validateAll()
    const response = await API.getFeeTable('/boating-licence-fees/')
    if (response._success) {
      this.feeValues = response
    } else {
      this.badRequest = true
    }
  },
  methods: {
    getEndDate (startDate) {
      let firstExpiryDate = moment([2021, 5, 30])
      while (firstExpiryDate.diff(startDate, 'days') < 60) {
        firstExpiryDate = moment([firstExpiryDate.year() + 3, 5, 30])
      }
      return firstExpiryDate
    },
    getProRataPrice (diff, unitPrice) {
      return Math.round(diff * unitPrice / 1095 * 100) / 100
    },
    getLeapDays (startDate, endDate) {
      let start = moment([startDate.year(), 1, 28])
      let days = 0
      while (endDate.diff(start, 'days') > 0) {
        if (
          start.isLeapYear() &&
          startDate.diff(start, 'days') <= 0 &&
          endDate.diff(start, 'days') > 0
        ) {
          days += 1
        }
        start = start.add(1, 'years')
      }
      return days
    },
    submit () {
      this.$validator.validateAll()
      if (!this.canSubmit) return

      const examinationFee = parseFloat(this.feeValues.examination_fee)
      const licenceFee = parseFloat(this.feeValues.licence_fee)
      const pwcFee = parseFloat(this.feeValues.pwc_fee)

      if (isNaN(examinationFee) || isNaN(licenceFee) || isNaN(pwcFee)) {
        this.answerSubtitle = 'Could not calculate estimate. Please contact MAST Online'
      }

      this.$validator.validateAll()
      if (!this.canSubmit) return

      let startDate = moment(this.startDate)
      let endDate = this.getEndDate(startDate)
      let diff = endDate.diff(startDate, 'days') + 2
      diff -= this.getLeapDays(startDate, endDate)
      console.log(diff)

      // nothing selected
      if (!this.includeLicence && !this.includePwc) {
        this.answer = NaN
        this.answerSubtitle = 'Please select a licence type'
        return
      }

      const age = startDate.diff(moment(this.dob), 'years')

      // under age
      if (age < 12) {
        this.answer = NaN
        this.answerSubtitle = 'You are too young to apply'
        return
      }

      // provisional
      if (age < 17) {
        this.answer = examinationFee
        this.answerSubtitle = 'Provisional Licence - Pro rata to ' + endDate.format('Do MMMM, YYYY')
        return
      }

      // full fee
      let answer = examinationFee
      if (this.includeLicence) {
        answer += this.getProRataPrice(diff, licenceFee)
      }
      if (this.includePwc) {
        answer += this.getProRataPrice(diff, pwcFee)
      }
      this.answer = answer
      this.answerSubtitle = 'Pro rata to ' + endDate.format('Do MMMM, YYYY')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/boating-licence-fees.vue